(() => {
  (function (Drupal, once) {
    'use strict';

    function getFieldSelect(form, fieldName) {
      if (!form) return null;
      return (
        form.querySelector(`select[name="${fieldName}"]`) ||
        form.querySelector(`select[name="${fieldName}[]"]`)
      );
    }

    function getFieldInputs(form, fieldName) {
      if (!form) return [];
      return Array.from(
        form.querySelectorAll(`input[name="${fieldName}"], input[name="${fieldName}[]"]`)
      );
    }

    function getCurrentValue(form, fieldName) {
      const select = getFieldSelect(form, fieldName);
      if (select) return select.value || '';
      const inputs = getFieldInputs(form, fieldName);
      const checked = inputs.find((i) => i.checked);
      return checked ? checked.value : '';
    }

    function setFieldValue(form, fieldName, value) {
      const select = getFieldSelect(form, fieldName);
      if (select) {
        select.value = value;
        return true;
      }
      const inputs = getFieldInputs(form, fieldName);
      if (inputs.length) {
        let matched = false;
        inputs.forEach((input) => {
          const isMatch = input.value === value;
          if (isMatch) matched = true;
          input.checked = isMatch;
        });
        return matched;
      }
      return false;
    }

    Drupal.behaviors.projectsSwitchFilter = {
      attach: function (context) {
        once('projectsSwitchFilter', '.status-switch', context).forEach(function (wrap) {
          const checkbox = wrap.querySelector('.form-check-input');
          if (!checkbox) return;

          const leftLabelEl = wrap.querySelector('.switch-label-left');
          const rightLabelEl = wrap.querySelector('.switch-label-right');
          const on = wrap.getAttribute('data-on') || '';
          const off = wrap.getAttribute('data-off') || '';
          const form = wrap.closest('form');
          const fieldName = wrap.getAttribute('data-name') || '';

          function syncUi() {
            if (checkbox.checked) {
              if (rightLabelEl) rightLabelEl.classList.add('fw-bold');
              if (leftLabelEl) leftLabelEl.classList.remove('fw-bold');
            } else {
              if (leftLabelEl) leftLabelEl.classList.add('fw-bold');
              if (rightLabelEl) rightLabelEl.classList.remove('fw-bold');
            }
          }

          function submitForm() {
            if (!form) return;
            const submitBtn = form.querySelector('.form-submit, input[type="submit"], button[type="submit"]');
            if (submitBtn) {
              submitBtn.click();
              return;
            }
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }
          }

          const currentValue = fieldName ? getCurrentValue(form, fieldName) : '';
          checkbox.checked = currentValue === on;
          syncUi();

          checkbox.addEventListener('change', function () {
            if (fieldName) {
              setFieldValue(form, fieldName, checkbox.checked ? on : off);
            }
            // RESET TOPIC FILTER
            const topicContainer = form ? form.querySelector('[data-filter-topic]') : null;
            const topicFieldName = topicContainer ? topicContainer.getAttribute('data-topic-field') : null;
            if (topicFieldName) {
              const select = getFieldSelect(form, topicFieldName);
              if (select) {
                const allOpt = Array.from(select.options).find((opt) => opt.value === 'All');
                select.value = allOpt ? 'All' : '';
              } else {
                const inputs = getFieldInputs(form, topicFieldName);
                inputs.forEach((input) => {
                  input.checked = input.value === 'All';
                });
              }
            }
            // END RESET TOPIC FILTER
            syncUi();
            submitForm();
          });

          checkbox.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
    };
  })(Drupal, once);
})();


